import React from 'react';
import { useLocation } from 'react-router-dom';
import SeoContentPage from '../../components/seo/SeoContentPage';
import RoiCalculator from '../../components/seo/RoiCalculator';
import NotFoundPage from '../NotFoundPage';
import { getContentByPath } from '../../data/contentRegistry';
import { pathnameWithoutLocale } from '../../utils/seoLocale';

export default function ContentRoutePage() {
  const location = useLocation();
  const pathWithoutLocale = pathnameWithoutLocale(location.pathname);
  const normalizedPath = pathWithoutLocale.endsWith('/') || pathWithoutLocale === '/'
    ? pathWithoutLocale
    : `${pathWithoutLocale}/`;
  const content = getContentByPath(normalizedPath) || getContentByPath(pathWithoutLocale);

  if (!content) {
    return <NotFoundPage />;
  }

  if (content.hasRoiCalculator) {
    return (
      <SeoContentPage content={content}>
        <RoiCalculator />
      </SeoContentPage>
    );
  }

  return <SeoContentPage content={content} />;
}
